export default __webpack_public_path__ + "static/media/roadmap_4.a2beb22b.png";